/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TenantAnagraficaUpdateDTO
 */
export interface TenantAnagraficaUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof TenantAnagraficaUpdateDTO
     */
    nome?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAnagraficaUpdateDTO
     */
    regioneId?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAnagraficaUpdateDTO
     */
    provinciaId?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAnagraficaUpdateDTO
     */
    comuneId?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAnagraficaUpdateDTO
     */
    nazioneId?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAnagraficaUpdateDTO
     */
    regione?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAnagraficaUpdateDTO
     */
    provincia?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAnagraficaUpdateDTO
     */
    comune?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAnagraficaUpdateDTO
     */
    localita?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAnagraficaUpdateDTO
     */
    cap?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAnagraficaUpdateDTO
     */
    indirizzo?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAnagraficaUpdateDTO
     */
    numeroCivico?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantAnagraficaUpdateDTO
     */
    note?: string;
}

/**
 * Check if a given object implements the TenantAnagraficaUpdateDTO interface.
 */
export function instanceOfTenantAnagraficaUpdateDTO(value: object): value is TenantAnagraficaUpdateDTO {
    return true;
}

export function TenantAnagraficaUpdateDTOFromJSON(json: any): TenantAnagraficaUpdateDTO {
    return TenantAnagraficaUpdateDTOFromJSONTyped(json, false);
}

export function TenantAnagraficaUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantAnagraficaUpdateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'nome': json['nome'] == null ? undefined : json['nome'],
        'regioneId': json['regioneId'] == null ? undefined : json['regioneId'],
        'provinciaId': json['provinciaId'] == null ? undefined : json['provinciaId'],
        'comuneId': json['comuneId'] == null ? undefined : json['comuneId'],
        'nazioneId': json['nazioneId'] == null ? undefined : json['nazioneId'],
        'regione': json['regione'] == null ? undefined : json['regione'],
        'provincia': json['provincia'] == null ? undefined : json['provincia'],
        'comune': json['comune'] == null ? undefined : json['comune'],
        'localita': json['localita'] == null ? undefined : json['localita'],
        'cap': json['cap'] == null ? undefined : json['cap'],
        'indirizzo': json['indirizzo'] == null ? undefined : json['indirizzo'],
        'numeroCivico': json['numeroCivico'] == null ? undefined : json['numeroCivico'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function TenantAnagraficaUpdateDTOToJSON(value?: TenantAnagraficaUpdateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'nome': value['nome'],
        'regioneId': value['regioneId'],
        'provinciaId': value['provinciaId'],
        'comuneId': value['comuneId'],
        'nazioneId': value['nazioneId'],
        'regione': value['regione'],
        'provincia': value['provincia'],
        'comune': value['comune'],
        'localita': value['localita'],
        'cap': value['cap'],
        'indirizzo': value['indirizzo'],
        'numeroCivico': value['numeroCivico'],
        'note': value['note'],
    };
}

